/* bl-product — fiche produit BellvoLux (code maison, sans dépendance) */
(function () {
  if (window.__blProduct) return;
  window.__blProduct = true;

  /* ---------- Galerie ---------- */
  class BlGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bl-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-bl-dot]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-bl-thumb]'));
      this.thumbList = this.querySelector('[data-bl-thumb-list]');
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      const prev = this.querySelector('[data-bl-thumbs-prev]');
      const next = this.querySelector('[data-bl-thumbs-next]');
      if (prev) prev.addEventListener('click', () => this.go(Math.max(0, this.index - 1)));
      if (next) next.addEventListener('click', () => this.go(Math.min(this.slides.length - 1, this.index + 1)));
      this.index = 0;
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
    }
    sync() {
      const left = this.track.scrollLeft;
      let best = 0, dist = Infinity;
      this.slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left - parseFloat(getComputedStyle(this.track).paddingLeft || 0));
        if (d < dist) { dist = d; best = i; }
      });
      this.mark(best);
    }
    mark(i) {
      this.index = i;
      this.dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
      this.thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
      const t = this.thumbs[i];
      if (t && this.thumbList) {
        const li = t.parentElement;
        const l = li.offsetLeft - this.thumbList.offsetLeft;
        if (l < this.thumbList.scrollLeft || l + li.offsetWidth > this.thumbList.scrollLeft + this.thumbList.clientWidth) {
          this.thumbList.scrollTo({ left: l - this.thumbList.clientWidth / 2 + li.offsetWidth / 2, behavior: 'smooth' });
        }
      }
    }
    go(i) {
      const s = this.slides[i];
      if (!s) return;
      const pad = parseFloat(getComputedStyle(this.track).paddingLeft || 0);
      this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft - pad, behavior: 'smooth' });
      this.mark(i);
    }
  }
  if (!customElements.get('bl-gallery')) customElements.define('bl-gallery', BlGallery);

  /* ---------- Formulaire : ajout au panier avec la quantité du palier ---------- */
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('bl:cart-updated'));
    const drawer = document.querySelector('cart-drawer');
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=' + sections.join(',') : '/?sections=' + sections.join(','))
      .then((r) => r.json())
      .then((data) => {
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: data, id: null });
          drawer.classList.remove('is-empty');
          return true;
        }
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          const tmp = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          const inner = tmp.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        }
        return false;
      })
      .catch(() => false);
  }

  class BlProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.btn = this.querySelector('[data-bl-atc]');
      this.err = this.querySelector('.bl-atc__error');
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.querySelectorAll('.bl-tier__input').forEach((r) => r.addEventListener('change', () => this.syncSticky()));
    }
    quantity() {
      const r = this.form.querySelector('input[name="quantity"]:checked') || this.form.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(r ? r.value : '1', 10) || 1);
    }
    syncSticky() {
      const r = this.form.querySelector('.bl-tier__input:checked');
      document.querySelectorAll('bl-sticky-atc .bl-price__now').forEach((el) => { if (r && r.dataset.price) el.textContent = r.dataset.price; });
    }
    submit(e) {
      e.preventDefault();
      if (this.busy) return;
      this.busy = true;
      const buttons = document.querySelectorAll('[form="' + this.form.id + '"], [data-bl-atc]');
      buttons.forEach((b) => b.classList.add('is-loading'));
      if (this.err) { this.err.hidden = true; this.err.textContent = ''; }
      const id = this.form.querySelector('input[name="id"]').value;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: this.quantity() }] })
      })
        .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
        .then(({ ok, j }) => {
          if (!ok) throw new Error(j.description || j.message || 'Error');
          return refreshCart().then((opened) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else if (!opened) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          });
        })
        .catch((er) => {
          if (this.err) { this.err.textContent = er.message; this.err.hidden = false; }
        })
        .finally(() => {
          this.busy = false;
          buttons.forEach((b) => b.classList.remove('is-loading'));
        });
    }
  }
  if (!customElements.get('bl-product-form')) customElements.define('bl-product-form', BlProductForm);

  /* ---------- Barre collante ---------- */
  class BlStickyAtc extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector('[data-bl-atc]');
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver((entries) => {
        const e = entries[0];
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        const b = this.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      }).observe(target);
    }
  }
  if (!customElements.get('bl-sticky-atc')) customElements.define('bl-sticky-atc', BlStickyAtc);

  /* ---------- Date d'expédition ---------- */
  function shipDates() {
    document.querySelectorAll('[data-bl-ship]').forEach((el) => {
      let days = parseInt(el.dataset.days || '1', 10);
      const d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      const out = el.querySelector('[data-bl-ship-date]');
      if (out) out.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }

  /* ---------- Vidéos clients ---------- */
  class BlVideoReel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bl-reel-track]');
      const prev = this.querySelector('[data-bl-reel-prev]');
      const next = this.querySelector('[data-bl-reel-next]');
      const step = () => (this.track.firstElementChild ? this.track.firstElementChild.offsetWidth + 16 : 200);
      const upd = () => {
        const over = this.track.scrollWidth > this.track.clientWidth + 4;
        if (prev) prev.hidden = !over || this.track.scrollLeft < 4;
        if (next) next.hidden = !over || this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      };
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      requestAnimationFrame(upd);
      const vids = Array.from(this.querySelectorAll('video[data-src]'));
      const load = (v) => { if (!v.src) { v.src = v.dataset.src; v.play().catch(() => {}); } };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } }), { rootMargin: '200px' });
        vids.forEach((v) => io.observe(v));
      } else vids.forEach(load);
      this.querySelectorAll('[data-bl-reel-open]').forEach((b) => b.addEventListener('click', () => this.open(b.dataset.src)));
    }
    open(src) {
      if (!src) return;
      const m = document.createElement('div');
      m.className = 'bl-reel-modal';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-modal', 'true');
      m.innerHTML = '<button type="button" class="bl-reel-modal__close" aria-label="Close">&times;</button>';
      const v = document.createElement('video');
      v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
      m.appendChild(v);
      const close = () => { v.pause(); m.remove(); document.removeEventListener('keydown', esc); };
      const esc = (e) => { if (e.key === 'Escape') close(); };
      m.addEventListener('click', (e) => { if (e.target === m || e.target.classList.contains('bl-reel-modal__close')) close(); });
      document.addEventListener('keydown', esc);
      document.body.appendChild(m);
      m.querySelector('button').focus();
    }
  }
  if (!customElements.get('bl-video-reel')) customElements.define('bl-video-reel', BlVideoReel);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shipDates);
  else shipDates();
})();
